import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
import policy from './whatsapp_contacts_ui.yaml';

export const contactsPolicy = policy;

const nativeId = value => {
  if (!/^[1-9]\d*$/.test(String(value))) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) ? id : null;
};

export const contactsScope = (accountId, inbox, config = contactsPolicy) => {
  if (
    config.enabled !== true ||
    nativeId(accountId) !== nativeId(config.account_id) ||
    !nativeId(config.account_id) ||
    !nativeId(config.inbox_id) ||
    nativeId(inbox?.id) !== nativeId(config.inbox_id) ||
    inbox?.channel_type !== 'Channel::Whatsapp' ||
    inbox?.provider !== 'whatsapp_cloud'
  ) {
    return null;
  }
  return { accountId: nativeId(accountId), inboxId: nativeId(inbox.id) };
};

export const normalizeContactPhone = value => {
  if (typeof value !== 'string' || !/^\+[\d\s().-]+$/.test(value.trim())) {
    return null;
  }
  const phone = parsePhoneNumberFromString(value.trim());
  return phone?.isValid() && !phone.ext ? phone.number : null;
};

export const contactPhone = (contact, sender) => {
  if (!nativeId(contact?.id) || nativeId(contact.id) !== nativeId(sender?.id)) {
    return null;
  }
  const primary = normalizeContactPhone(contact?.phone_number);
  if (primary) return primary;
  return normalizeContactPhone(sender?.phone_number);
};

export const conversationRoute = (scope, conversationId) => {
  if (!nativeId(conversationId)) throw new Error('response_mismatch');
  return {
    name: 'conversation_through_inbox',
    params: {
      accountId: String(scope.accountId),
      inbox_id: String(scope.inboxId),
      conversation_id: String(conversationId),
    },
  };
};

export const hasNativeId = value => nativeId(value) !== null;
